import { CommonResponse } from './shared.interface';

export interface GetReportTemplatesPayload {
  params: string;
}

export interface FilterReportTemplates {
  id: string;
  columnName: string;
  columnType: number;
  condition: number;
  operator: string | null;
  tableName: string;
  value: string;
  locked?: boolean;
}

export interface ReportTemplateItem {
  id: number;
  name: string;
  creatorName: string;
  creationTime: string;
  filters?: FilterReportTemplates[];
  visualizationType?: string;
  visualizationTypeId?: number;
  xAxisColumn?: GetByIdItem | null;
  yAxisColumn?: GetByIdItem | null;
}

export interface GetReportTemplatesResponse extends CommonResponse {
  result: {
    totalCount: number;
    items: ReportTemplateItem[];
  };
}

export enum REPORT_TEMPLATES_COLUMNS {
  NAME = 'name',
  TYPE = 'type',
  CREATOR = 'creator',
  CREATION_TIME = 'creationTime',
  ACTIONS = 'actions',
}

export interface GetByIdItem {
  tableName: string;
  name: string;
  type: number;
  displayType: string | number | null;
}

export interface DownloadReportPayload {
  id: number;
  type: number;
  filters: FilterReportTemplates[];
}

export interface DownloadReportResponse extends CommonResponse {
  result: {
    fileName: string;
    fileType: string;
    content: string;
  };
}

export interface GetAllVisualizationsResponse extends CommonResponse {
  result: {
    id: string;
    name: string;
  }[];
}

export interface JoinRow {
  id: number;
  leftTable: string;
  rightTable: string;
  leftColumn: string;
  rightColumn: string;
  leftDisplayType?: string;
}

export interface ApiJoinRow {
  id?: number;
  column?: {
    name: string;
    tableName: string;
    displayType: string;
    type: number;
  };
  joinColumn?: {
    name: string;
    tableName: string;
    displayType: string;
    type: number;
  };
}

export interface VisualizationItemPayload {
  name: string;
  displayName?: string;
  type: number;
  displayType: string | null;
  tableName: string;
}

export interface SortingRule {
  column: VisualizationItemPayload;
  direction: number;
  order: number;
  name?: string;
  displayName?: string;
}

export interface ExecuteQueryPayload {
  query: {
    tableName: string;
    joins: JoinRow[];
    sorting?: SortingRule[];
    filters: FilterReportTemplates[];
    displayColumns: VisualizationItemPayload[];
    rowLimit?: number;
  };
}

export interface ExecuteQueryResponse extends CommonResponse {
  result: Record<string, any>[];
}

export interface DistributeQueryPayload {
  query: {
    tableName: string;
    joins: JoinRow[];
    filters: FilterReportTemplates[];
    displayColumns: VisualizationItemPayload[];
  };
  column: VisualizationItemPayload;
  timelapseType: number;
}

export interface DistributeQueryResponse extends CommonResponse {
  result: {
    labels: string[];
    values: number[];
  };
}

export interface GetReportingByIdResponse extends CommonResponse {
  result: ReportTemplateItem;
}

export interface ReportChartDataPayload {
  reportId: number;
  filters: FilterReportTemplates[];
  column: VisualizationItemPayload;
  timelapseType: number;
  from?: string;
  to?: string;
}

export interface RunReportFilter {
  id: string;
  columnName: string;
  tableName: string;
  columnType: number;
  condition: number;
  operator: string | null;
  value: string | number | boolean | null;
}

export interface RunReportPayload {
  id: number;
  filters: RunReportFilter[];
}

export interface RunReportResponse extends CommonResponse {
  result: Record<string, any>[];
}

export interface ReportTemplateConfiguration {
  tableName: string;
  joins?: JoinRow[];
  groupBy?: VisualizationItemPayload;
  aggregates?: { func: string; column?: string }[];
  filters?: FilterReportTemplates[];
  sorting?: SortingRule[];
  visualization: any;
  query?: {
    tableName?: string;
    joins?: ApiJoinRow[];
    aggregates?: { func: string; column?: string }[];
    groupBy?: VisualizationItemPayload[];
    filters?: FilterReportTemplates[];
    displayColumns?: Array<{
      name: string;
      aggregateFunctionType?: string | null;
      displayType?: string;
      displayName?: string;
      tableName?: string;
    }>;
  };
  name?: string;
}
